export default "__VITE_PUBLIC_ASSET__79579da4__"